import { render, staticRenderFns } from "./guanyu.vue?vue&type=template&id=21de9a4e"
import script from "./guanyu.vue?vue&type=script&lang=js"
export * from "./guanyu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports